import { formatMoney, pluralize } from '@travelata-libs/utils';
import type { ActiveLottery } from '@/shared/api/getActiveLottery';
import { SERP_DREAM_TOUR_BANNER_TEXTS } from '../config/texts';

export interface DreamTourBannerView {
  title: string;
  subtitle: string;
  action: string;
  imageUrl: string;
  hotelName: string;
  hotelLocation: string;
  rating: number;
  reviewsCount: number;
}

const PROTOCOL_RE = /^https?:/;

function getHotelName({ name, stars }: ActiveLottery['hotel']): string {
  return stars ? `${name} ${stars}*` : name;
}

function getHotelLocation({ countryName, cityName }: ActiveLottery['hotel']): string {
  return [countryName, cityName].filter(Boolean).join(', ');
}

export function getDreamTourBannerView(lottery: ActiveLottery): DreamTourBannerView {
  const texts = SERP_DREAM_TOUR_BANNER_TEXTS;
  const rubles = pluralize([...texts.rubleForms], lottery.price, false);

  return {
    title: `${texts.title} ${lottery.direction}!`,
    subtitle: `${texts.subtitle} ${formatMoney(lottery.couponAmount)}`,
    action: `${texts.action} ${lottery.price} ${rubles}`,
    imageUrl: lottery.bannerUrl.replace(PROTOCOL_RE, ''),
    hotelName: getHotelName(lottery.hotel),
    hotelLocation: getHotelLocation(lottery.hotel),
    rating: lottery.hotel.rating,
    reviewsCount: lottery.hotel.reviewsQty,
  };
}
